import {Route} from 'react-router';
import {DynamicFormPlayground} from 'App/components/dynamicForms/Playground';
import {basePath} from 'App/api/config';

const isDev = !basePath?.startsWith('https://api.shipwell.com/');

export const ConditionalDynamicFormPlayGroundRoute = isDev ? (
  <Route path="/dynamic-form-playground" component={DynamicFormPlayground} />
) : null;
